export default axios => ({
  storeMultiple: ({ house, number_start_from, floor_count }) => axios.post('floors/multiple', {
    house_id: house?.id,
    number_start_from,
    floor_count
  })
})
